import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { accessToken, authReady } = useContext(AuthContext);

  // Todavía restaurando la sesión desde el storage seguro (async) — no decidir
  // la ruta con esto, o cada arranque de la app flashea a /login.
  if (!authReady) return null;

  return accessToken ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
